import Checkbox from "components/checkbox/Checkbox";
import messages from "messages";
import { useState, useEffect } from "react";
import { FormControl, InputGroup } from "react-bootstrap";
import getClasses from "utils/getClasses";
import isFreeOfCharge from "../../../../../../utils/isFreeOfCharge";
import styles from "./SessionTypePriceEditor.module.scss";

const PLACEHOLDER = "45";
type Props = {
  value: SessionType["price"] | undefined;
  onChangeValue: (arg: SessionType["price"] | undefined) => void;
  onFocus: () => void;
  onCheck: () => void;
};
const SessionTypePriceEditor = ({
  value,
  onChangeValue,
  onFocus,
  onCheck,
}: Props) => {
  // remove the impact of free checked
  const [valueBeforeChecked, setValueBeforeChecked] = useState<string>("");

  const [freeChecked, setFreeChecked] = useState(isFreeOfCharge(value));

  useEffect(() => {
    setFreeChecked(isFreeOfCharge(value));
  }, [value]);

  return (
    <div className={styles["container"]}>
      <InputGroup hasValidation className={styles["session-type-price-editor"]}>
        <InputGroup.Text
          className={getClasses(
            styles["unit"],
            freeChecked && styles["unit--disabled"],
          )}
        >
          {"$"}
        </InputGroup.Text>
        <FormControl
          className={styles["input"]}
          type="number"
          min="0"
          defaultValue={valueBeforeChecked || value}
          onChange={(e) =>
            onChangeValue(e.target.value === "" ? undefined : +e.target.value)
          }
          placeholder={PLACEHOLDER}
          disabled={freeChecked}
          onFocus={onFocus}
        />
      </InputGroup>
      <Checkbox
        className={styles["check"]}
        label={messages.free}
        checked={freeChecked}
        variant="rectangle"
        onChange={(e) => {
          onCheck();
          setFreeChecked(e.target.checked);
          if (e.target.checked) {
            setValueBeforeChecked(value?.toString() || "");
            return onChangeValue(0);
          }
          onChangeValue(
            valueBeforeChecked === undefined ? undefined : +valueBeforeChecked,
          );
          return setValueBeforeChecked("");
        }}
      />
    </div>
  );
};
export default SessionTypePriceEditor;
